import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from 'src/pages/CandidatesDetailsPage/messages';

const cancelUnavailabilities = async (uuid: string) => {
  return await putRequest(API.PUT.cancelUnavailabilities(uuid));
};

export const useCancelUnavailabilities = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: cancelUnavailabilities,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.USER_UNAVAILABILITIES],
      });
      handleSuccess(formatMessage(messages.unavailabilityCancelled));
    },
    onError: handleError,
  });
};
